<template>
  <div class="edited-links-component">
  <div :class="wrapperClasses">
    <div class="table-responsive">
      <table class="addon-table" :class="tableClass">
        <tr>
          <th class="col-link-id">Link Id</th>
          <th v-if="!PPOrder && !mediaLinks" class="col-da-dr">DA/DR</th>
          <th v-if="PPOrder && !mediaLinks" class="col-da">DA</th>
          <th v-if="mediaLinks" class="col-authority">Authority</th>
          <th v-if="PPOrder && !mediaLinks" class="col-dr">DR</th>
          <th v-if="!mediaLinks" class="col-category">Category</th>
          <th class="col-destination">Destination URL</th>
          <th class="col-placement">Placement</th>
          <th class="col-anchor">Anchor Text</th>
          <th v-if="!mediaLinks" class="col-addons">Updated Addons</th>
          <template v-if="PPOrder && !mediaLinks">
            <th class="col-spam">Spam</th>
            <th class="col-traffic">Traffic</th>
            <th class="col-do-follow">Do Follow</th>
          </template>
          <template v-if="mediaLinks">
            <th class="col-location">Location</th>
            <th class="col-traffic">Traffic</th>
            <th class="col-sample-post">Sample Post</th>
            <th class="col-rel-attribute">Rel Attribute</th>
            <th class="col-sponsored-tag">Sponsored Tag</th>
            <th class="col-turnaround">Turnaround Time</th>
            <th class="col-industry">Industry</th>
          </template>
          <th class="col-price">Price</th>
          <th class="col-status">Status</th>
        </tr>
        <tr v-for="order in groupedLinks" :key="order.link_id">
          <td class="col-link-id">
            <span>{{ order.link_id }}</span>
          </td>
          <td v-if="!PPOrder && !mediaLinks" class="col-da-dr">
            <div :class="['text-break-wrapper', order.product_names.length > 1]">
              <div
                v-for="(p, i) in order.product_names"
                :key="i"
                :class="['text-item', order.types[i] === 'Old' && order.product_names.length > 1 ? 'strikethrough' : '']"
              >
                {{ p }}
              </div>
            </div>
          </td>
          <td v-if="PPOrder && !mediaLinks" class="col-da">
            <div :class="['text-break-wrapper', order.exact_da.length > 1]">
              <div
                v-for="(p, i) in order.exact_da"
                :key="i"
                :class="['text-item', order.types[i] === 'Old' && order.exact_da.length > 1 ? 'strikethrough' : '']"
              >
                {{ p }}
              </div>
            </div>
          </td>
          <td v-if="mediaLinks" class="col-authority">
            <div :class="['text-break-wrapper', order.authority.length > 1]">
              <div
                v-for="(sc, i) in order.authority"
                :key="i"
                :class="['text-item', order.types[i] === 'Old' && order.authority.length > 1 ? 'strikethrough' : '']"
              >
                {{ sc }}
              </div>
            </div>
          </td>
          <td v-if="PPOrder && !mediaLinks" class="col-dr">
            <div :class="['text-break-wrapper', order.exact_dr.length > 1]">
              <div
                v-for="(p, i) in order.exact_dr"
                :key="i"
                :class="['text-item', order.types[i] === 'Old' && order.exact_dr.length > 1 ? 'strikethrough' : '']"
              >
                {{ p }}
              </div>
            </div>
          </td>
          <td v-if="!mediaLinks" class="col-category">
            <div :class="['text-break-wrapper', order.primary_categories.length > 1]">
              <div
                v-for="(pc, i) in order.primary_categories"
                :key="i"
                :class="['text-item', order.types[i] === 'Old' && order.primary_categories.length > 1 ? 'strikethrough' : '']"
              >
                {{ pc }}
              </div>
            </div>
          </td>
          <td class="col-destination">
            <div :class="['text-break-wrapper', order.urls.length > 1]">
              <div
                v-for="(url, i) in order.urls"
                :key="i"
                :class="['text-item', order.types[i] === 'Old' && order.urls.length > 1 ? 'strikethrough' : '']"
              >
                {{ url }}
              </div>
            </div>
          </td>
          <td class="col-placement">
            <div :class="['text-break-wrapper', order.placement_authority.length > 1]">
              <div
                v-for="(pa, i) in order.placement_authority"
                :key="i"
                :class="['text-item', order.types[i] === 'Old' && order.placement_authority.length > 1 && pa != 'N/A' ? 'strikethrough' : '']"
              >
                {{ pa }}
              </div>
            </div>
          </td>
          <td class="col-anchor">
            <div :class="['text-break-wrapper', order.texts.length > 1]">
              <div
                v-for="(text, i) in order.texts"
                :key="i"
                :class="['text-item', order.types[i] === 'Old' && order.texts.length > 1 ? 'strikethrough' : '']"
              >
                {{ text }}
              </div>
            </div>
          </td>
          <td v-if="!mediaLinks" class="col-addons">
            <div v-if="order.addon_items?.length" :class="['text-break-wrapper updated-addons', order.addon_items.length > 1]">
              <div
                v-for="(addon, i) in order.addon_items"
                :key="`addon-${order.link_id}-${i}`"
                class="text-item"
              >
                {{ addon }}
              </div>
            </div>
            <span v-else>—</span>
          </td>
          <template v-if="PPOrder && !mediaLinks">
            <td class="col-spam">
              <div :class="['text-break-wrapper', order.spam_score.length > 1]">
                <div
                  v-for="(sc, i) in order.spam_score"
                  :key="i"
                  :class="['text-item', order.types[i] === 'Old' && order.spam_score.length > 1 ? 'strikethrough' : '']"
                >
                  {{ sc }}
                </div>
              </div>
            </td>
            <td class="col-traffic">
              <div :class="['text-break-wrapper', order.traffic.length > 1]">
                <div
                  v-for="(sc, i) in order.traffic"
                  :key="i"
                  :class="['text-item', order.types[i] === 'Old' && order.traffic.length > 1 ? 'strikethrough' : '']"
                >
                  {{ sc }}
                </div>
              </div>
            </td>
            <td class="col-do-follow">
              <div :class="['text-break-wrapper', order.do_follow.length > 1]">
                <div
                  v-for="(sc, i) in order.do_follow"
                  :key="i"
                  :class="['text-item', order.types[i] === 'Old' && order.do_follow.length > 1 ? 'strikethrough' : '']"
                >
                  {{ sc }}
                </div>
              </div>
            </td>
          </template>
          <template v-if="mediaLinks">
            <td class="col-location">
              <div :class="['text-break-wrapper', order.location.length > 1]">
                <div
                  v-for="(sc, i) in order.location"
                  :key="i"
                  :class="['text-item', order.types[i] === 'Old' && order.location.length > 1 ? 'strikethrough' : '']"
                >
                  {{ sc }}
                </div>
              </div>
            </td>
            <td class="col-traffic">
              <div :class="['text-break-wrapper', order.traffic.length > 1]">
                <div
                  v-for="(sc, i) in order.traffic"
                  :key="i"
                  :class="['text-item', order.types[i] === 'Old' && order.traffic.length > 1 ? 'strikethrough' : '']"
                >
                  {{ sc }}
                </div>
              </div>
            </td>
            <td class="col-sample-post">
              <div :class="['text-break-wrapper sample-post-wrapper', order.sample_post.length > 1]">
                <span
                  v-for="(sc, i) in order.sample_post"
                  :key="i"
                  :class="['text-item sample-post-item', order.types[i] === 'Old' && order.sample_post.length > 1 ? 'strikethrough' : '']"
                  v-b-tooltip.hover.top="getSamplePostTooltip(sc)"
                >
                  <span class="sample-post-text">{{ formatSamplePostDisplay(sc) }}</span>
                </span>
              </div>
            </td>
            <td class="col-rel-attribute">
              <div :class="['text-break-wrapper', order.rel_attribute.length > 1]">
                <div
                  v-for="(sc, i) in order.rel_attribute"
                  :key="i"
                  :class="['text-item', order.types[i] === 'Old' && order.rel_attribute.length > 1 ? 'strikethrough' : '']"
                >
                  {{ sc }}
                </div>
              </div>
            </td>
            <td class="col-sponsored-tag">
              <div :class="['text-break-wrapper', order.sponsored_tag.length > 1]">
                <div
                  v-for="(sc, i) in order.sponsored_tag"
                  :key="i"
                  :class="['text-item', order.types[i] === 'Old' && order.sponsored_tag.length > 1 ? 'strikethrough' : '']"
                >
                  {{ sc }}
                </div>
              </div>
            </td>
            <td class="col-turnaround">
              <div :class="['text-break-wrapper', order.turnaround_time.length > 1]">
                <div
                  v-for="(sc, i) in order.turnaround_time"
                  :key="i"
                  :class="['text-item', order.types[i] === 'Old' && order.turnaround_time.length > 1 ? 'strikethrough' : '']"
                >
                  {{ sc }}
                </div>
              </div>
            </td>
            <td class="col-industry">
              <div :class="['text-break-wrapper', order.industry.length > 1]">
                <div
                  v-for="(sc, i) in order.industry"
                  :key="i"
                  :class="['text-item', order.types[i] === 'Old' && order.industry.length > 1 ? 'strikethrough' : '']"
                >
                  {{ sc }}
                </div>
              </div>
            </td>
          </template>
          <td class="col-price">
            <div :class="['text-break-wrapper', order.prices.length > 1]">
              <div
                v-for="(price, i) in order.prices"
                :key="i"
                :class="['text-item', order.types[i] === 'Old' && order.prices.length > 1 ? 'strikethrough' : '']"
              >
                {{ numberFormat(price, "currency") }}
              </div>
            </div>
          </td>
          <td class="col-status">
            <span>{{ order.statuses[0] }}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
  </div>
</template>

<script>
import { numberFormat } from "@/prod.js";

export default {
  props: ["editLinks","groupedLinks","PPOrder","mediaLinks"],
  data() {
    return {
      numberFormat,
      checkedItems: [],
    };
  },
  computed: {
    wrapperClasses() {
      const classes = ["editor-order-table"];
      if (this.mediaLinks) {
        classes.push("media-links-edited-order-table");
      } else if (this.PPOrder) {
        classes.push("pp-edited-order-table");
      } else {
        classes.push("standard-edited-order-table");
      }
      return classes;
    },
    tableClass() {
      if (this.mediaLinks) return "media-links-edited-table";
      if (this.PPOrder) return "pp-edited-table";
      return "standard-edited-table";
    },
  },
  methods: {
    openOrderSidebar(value) {
      var arr = this.editLinks;
      arr = arr.filter(x => x.link_id === value && (x.type === 'New' || x.type === 'Updated'));
      this.$emit('openOrderSidebar', arr[0])
    },
    hasType(order, type) {
      return (order?.types || []).some((t) => String(t || "").toLowerCase() === String(type || "").toLowerCase());
    },
    showOldAddonIndicator(order) {
      const hasUpdated = this.hasType(order, "updated");
      const hasNew = this.hasType(order, "new");
      const hasOldAddons = Array.isArray(order?.old_addon_items) && order.old_addon_items.length > 0;
      return hasUpdated && !hasNew && hasOldAddons;
    },
    oldAddonTooltip(order) {
      return (order?.old_addon_items || []).join("\n");
    },
    formatSamplePostDisplay(value) {
      if (value == null || value === "" || value === "--" || value === "—") {
        return value ?? "—";
      }
      return String(value).trim();
    },
    getSamplePostTooltip(value) {
      if (value == null || value === "" || value === "--" || value === "—") return "";
      const s = String(value).trim();
      return s.length > 22 ? s : "";
    },
  },
};
</script>
